<template>
	<pre>{{ arg }}</pre>
</template>

<script>
export default {
	name: 'ArgDefault',
	props: {
		arg: {
			validator() {
				// ArgDefault should in theory never happen and we don't know it's type.
				return true
			},
		},
	},
	created() {
		// eslint-disable-next-line no-console
		console.warn('ArgDefault means the arg has an unexpected type')
	},
}
</script>
